import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { useTrialStatus } from '@/modules/plans/hooks/useTrialStatus'

export default function OportunidadesPostTrialBanner() {
  const { loading, error, postTrialOnTrialPlan } = useTrialStatus()

  if (loading) return null
  if (error) return null
  if (!postTrialOnTrialPlan) return null

  return (
    <div className="mb-3 rounded-lg border border-amber-500/70 bg-gradient-to-r from-amber-500/20 via-red-500/25 to-amber-700/20 px-3 py-3 text-xs text-amber-50 shadow-md md:px-4 md:py-3 md:text-sm">
      <div className="flex items-start gap-2">
        <div className="mt-[2px] rounded-full bg-amber-500/40 p-1.5 text-amber-50">
          <AlertTriangle className="h-4 w-4" />
        </div>
        <div>
          <div className="font-semibold">
            Voce esta no plano Freemium
          </div>
          <div className="mt-1 text-amber-50/90">
            No Freemium voce ve apenas parte das oportunidades. Para liberar todas as moedas,
            escolha um plano pago.
          </div>
        </div>
      </div>
    </div>
  )
}
